import { render, staticRenderFns } from "./titleStyle.vue?vue&type=template&id=7a54a0cb&scoped=true"
import script from "./titleStyle.vue?vue&type=script&lang=js"
export * from "./titleStyle.vue?vue&type=script&lang=js"
import style0 from "./titleStyle.vue?vue&type=style&index=0&id=7a54a0cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a54a0cb",
  null
  
)

export default component.exports